import React, { useContext, useLayoutEffect, useEffect, useState } from "react";
import { PortalContext } from "App";
import OPOnlineIframe from "../../../iframe-component/operation-online/OPOnIframe";

const OnlineMerchantDetail = ({ path, redirectFn }) => {
  const stateContext = useContext(PortalContext);
  const { detailPageState } = stateContext;

  const [merchantId, setMerchantId] = useState("");

  useLayoutEffect(() => {
    const sessionState = JSON.parse(sessionStorage.getItem("state"));
    if (detailPageState && detailPageState[path]) {
      setMerchantId(detailPageState[path].merchantId);
    } else if (sessionState && sessionState[path]) {
      setMerchantId(sessionState[path].merchantId);
    } else {
      if (merchantId == "") setMerchantId("close");
    }
  }, [detailPageState[path]]);

  useEffect(() => {
    if (merchantId == "close") {
      redirectFn("close", { tabId: path });
    }
  }, [merchantId]);

  // uses /merchant/list with merchantIdRedirect query parameter to redirect into merchant/info with the desired merchantId
  const urlPath = `/online-pay/merchant/merchant-list${
    merchantId ? "?merchantIdRedirect=" + merchantId : ""
  }`;

  return <OPOnlineIframe path={urlPath} />;
};

export default React.memo(OnlineMerchantDetail);
